/**
 * WagmiProviderWrapper - Provides WagmiProvider immediately (it's lightweight)
 *
 * WagmiProvider itself is not heavy - the issue is the wallet vendor bundle (AppKit/Reown).
 * That gets loaded when components use AppKit hooks, which we defer via lazy loading.
 */
import { type ReactNode } from 'react'
import { WagmiProvider } from 'wagmi'
import { config } from '../config/wagmi'

interface WagmiProviderWrapperProps {
  children: ReactNode
}

export function WagmiProviderWrapper({ children }: WagmiProviderWrapperProps) {
  return <WagmiProvider config={config}>{children}</WagmiProvider>
}
